export default {
    methods: {
        filterArray (testArray) {
            let index = -1;
            const arrLength = testArray ? testArray.length : 0;
            let resIndex = -1;
            const result = [];

            while (++index < arrLength) {
                const value = testArray[index];

                if (value) {
                    result[++resIndex] = value;
                }
            }

            return result;
        }
    }
};
